import { storageHelper, navigationHelper, alertHelper, firebaseConfig as FC } from '../../config';

const SCHEMA = process.env.REACT_APP_SCHEMA;
const DOMAIN = process.env.REACT_APP_DOMAIN;
const REACT_APP_IS_WEB = process.env.REACT_APP_IS_WEB;
const REACT_APP_FIREBASE_PASSWORD = process.env.REACT_APP_FIREBASE_PASSWORD;

const apiRoot = process.env.REACT_APP_API_ROOT || `${SCHEMA}://api.${DOMAIN}`;
const rootUrl = process.env.REACT_APP_HOSTNAME || `${SCHEMA}://${DOMAIN}`;
const uploadRoot = process.env.REACT_APP_STORAGE || `${SCHEMA}://uploads.${DOMAIN}`;
const isWeb = process.env.REACT_APP_IS_WEB === 'true';
const firebasePassword = process.env.REACT_APP_FIREBASE_PASSWORD;

const siteTitle = () => 'EduCoach';

const parseItem = (key) => storageHelper.getItem(key) || null;
const identity = parseItem('authentication');
const token = parseItem('token');

const authToken = () => token || null;

const authHeader = () => {
    return token
        ? { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
        : { 'Content-Type': 'application/json' };
};

const logout = () => {
    storageHelper.removeItem('authentication');
    storageHelper.removeItem('token');
    setTimeout(() => navigation('logout'), 900);
    firebaseLogout();
    fbLogout();
};

const fbLogout = () => {};

const clearAll = () => logout();

const storeItem = (key, data) => storageHelper.setItem(key, data);

// Firebase Setup
const firebase = FC;
const db = FC.db;
const storage = FC.storage;
const app = FC.app;
const auth = app.auth();
const ref = db.ref();

const sendToFirebase = async (ref, data) => await db.ref(ref).set(data);

const isNotified = (recipients) => {
    recipients?.map(async (recipient_id) => {
        await db.ref(`User/${recipient_id}`).update({ 'is_notified': Date.now() });
    });
    return true;
};

const firebaseRegister = (username) => {
    const authentication = parseItem('authentication');
    const user = authentication?.user;
    return app.auth()
        .createUserWithEmailAndPassword(username, firebasePassword)
        .then((authUser) => sendToFirebase(`/User/${user.id}`, user))
        .catch((error) => {
            console.log("Register Error:", error.code, error.message);
        });
};

const firebaseLogin = async (username) => {
    const authentication = await parseItem('authentication');
    const user = authentication?.user;
    return app.auth()
        .signInWithEmailAndPassword(username, firebasePassword)
        .then((authUser) => {
            sendToFirebase(`/User/${user.id}`, user);
            return authUser;
        })
        .catch(async (error) => {
            if (error.code === 'auth/user-not-found') {
                return await firebaseRegister(username);
            }
            console.log(error.code, error.message);
        });
};

const firebaseUpdatePassword = (newPassword) => {
    const user = app.auth().currentUser;
    user.updatePassword(newPassword).catch(console.error);
};

const firebaseLogout = () => app.auth().signOut();

const messageToFirebase = async (data, key = null) => {
    const { message, recipients, group, item } = data;
    let messageKey = key || db.ref('/UserMessage').push().key;
    recipients.key = messageKey;

    await sendToFirebase(`/UserMessage/${messageKey}/${message.created_at}`, message);
    await sendToFirebase(`/UserMessageRecipient/${messageKey}`, recipients);
    if (group) await sendToFirebase(`/UserMessageGroup/${messageKey}`, { ...group, key: messageKey });
    if (item) await sendToFirebase(`/UserMessageItem/${messageKey}`, { ...item, key: messageKey });

    return messageKey;
};

const deleteFirebaseMessage = async (messageKey) => {
    if (!messageKey) return false;
    await db.ref(`/UserMessage/${messageKey}`).remove();
    await db.ref(`/UserMessageRecipient/${messageKey}`).remove();
    await db.ref(`/UserMessageGroup/${messageKey}`).remove();
    await db.ref(`/UserMessageItem/${messageKey}`).remove();
};

const readMessageThread = (messageKey, user_id) => {
    let update = {};
    update[`/UserMessageRecipient/${messageKey}/recipients/${user_id}`] = { id: user_id, unread: 0, status: 'read' };
    db.ref().update(update);
};

const readMessage = (messageKey, createdAt, user_id) => {
    let update = {};
    update[`/UserMessage/${messageKey}/${createdAt}/recipients/${user_id}`] = { id: user_id, status: 'read' };
    db.ref().update(update);
};

const ObjectToArray = (objs) => {
    return objs ? Object.values(objs) : [];
};

const getUser = () => identity?.user || null;
const isOwner = (user_id) => identity?.id === user_id;

const clearErrorMessages = () => { this.errors = []; };

const handleHttpError = (error) => { throw new Error(error || 'Server Error'); };

const showErrors = (dispatch, exceptionMsg, alertSelectors) => {
    const exception = exceptionMsg;
    if (exception instanceof TypeError) {
        dispatch(alertSelectors.error(`${exception.name}: ${exception.message}`));
    } else if (typeof exception === 'string') {
        dispatch(alertSelectors.error(exception));
    } else {
        exception?.text?.().then(message => {
            const errorMessage = JSON.parse(message);
            if (errorMessage.status === 401) {
                console.log('Unauthorized:', errorMessage.message);
            } else if (errorMessage.status === 500) {
                dispatch(alertSelectors.error(errorMessage.message));
            }
            const errors = errorMessage.data?.errors || [];
            if (!errors.length) {
                dispatch(alertSelectors.error(errorMessage.message));
            } else {
                errors.forEach(item => dispatch(alertSelectors.error(item)));
            }
        });
    }
};

const IsJson = (str) => {
    try {
        JSON.parse(str);
        return true;
    } catch {
        return false;
    }
};

const requestOptions = (method = "GET", params = null) => {
    return {
        method,
        headers: authHeader(),
        body: params ? JSON.stringify(params) : null,
    };
};

const requestParamsQuery = (params) => {
    return Object.entries(params)
        .map(([k, v]) => (v !== undefined && v !== null && v !== '') ? `${encodeURIComponent(k)}=${encodeURIComponent(v)}` : null)
        .filter(Boolean)
        .join('&');
};

const requestParams = (url, params) => {
    const query = requestParamsQuery(params);
    return query ? `${url}?${query}` : url;
};

const request = (url, options) => {
    return fetch(url, options).then(response => {
        if (!response.ok) throw response;
        return response.json();
    });
};

const httpURL = (url) => isWeb ? new URL(url) : url;

const navigation = (location, is_reload = false, params = null) => {
    let query = params ? requestParamsQuery(params) : null;
    switch (location) {
        case 'welcome': navigationHelper.welcome(is_reload); break;
        case 'services': navigationHelper.service(is_reload); break;
        case 'home': navigationHelper.home(is_reload); break;
        case 'login': navigationHelper.login(); break;
        case 'logout': navigationHelper.logout(); break;
        case 'received': navigationHelper.receivedOffer(); break;
        case 'service-search': navigationHelper.serviceSearch(is_reload); break;
        case 'message': navigationHelper.message(is_reload, query); break;
        default:
            if (location.startsWith('offers-')) {
                navigationHelper.offersLocation(location.split('-').join('/'));
            }
            break;
    }
};

const messageAlert = (message) => alertHelper.confirm(message);

const truncateString = (string, length) => string.length > length ? string.slice(0, length) + '...' : string;
const truncateWord = (string, length) => string.split(" ").slice(0, length).join(" ");
const html2text = (html) => html ? html.replace(/<\/?[^>]+>/ig, " ") : '';
const capitalize = (s) => typeof s === 'string' ? s.charAt(0).toUpperCase() + s.slice(1) : '';
const checkImage = (uri) => /\.(jpeg|jpg|gif|png)$/.test(uri || '');
const fileExtension = (url) => url?.split('.').pop().split(/\#|\?/)[0];
const classIcon = (ext) => {
    if (!ext) return 'file';
    if (/(xls|xlsx|csv)$/.test(ext)) return 'excel';
    if (/(ppt|pptx|pps)$/.test(ext)) return 'powerpoint';
    if (/(doc|docx|odt|rtf)$/.test(ext)) return 'word';
    if (/pdf|txt$/.test(ext)) return 'pdf';
    return 'file';
};

const listToTree = (data, options = {}) => {
    const { idKey = 'id', parentKey = 'parent', childrenKey = 'children' } = options;
    const tree = [], childrenOf = {};
    data.forEach(item => {
        const id = item[idKey], parentId = item[parentKey] || 0;
        childrenOf[id] = childrenOf[id] || [];
        item[childrenKey] = childrenOf[id];
        if (parentId !== 0) {
            childrenOf[parentId] = childrenOf[parentId] || [];
            childrenOf[parentId].push(item);
        } else {
            tree.push(item);
        }
    });
    return tree;
};

const convertTimestamptoTime = (unixTimestamp) => {
    const date = new Date(unixTimestamp * 1000);
    return `${date.getUTCHours().toString().padStart(2, '0')}:${date.getUTCMinutes().toString().padStart(2, '0')}`;
};

const getExperience = (value) => ({
    '1': '1 year',
    '2': '2 - 5 years',
    '3': '6 - 10 years',
    '4': '11 - 20 years',
    '5': '21+ years',
}[value] || 'Not Set');

export const globalService = {
    identity,
    getUser,
    rootUrl,
    isOwner,
    clearErrorMessages,
    siteTitle,
    handleHttpError,
    request,
    requestOptions,
    requestParamsQuery,
    requestParams,
    apiRoot,
    uploadRoot,
    authHeader,
    authToken,
    showErrors,
    logout,
    storeItem,
    parseItem,
    httpURL,
    navigation,
    IsJson,
    sendToFirebase,
    messageToFirebase,
    deleteFirebaseMessage,
    readMessageThread,
    readMessage,
    firebase,
    ObjectToArray,
    truncateString,
    messageAlert,
    truncateWord,
    app,
    storage,
    db,
    ref,
    auth,
    html2text,
    firebaseRegister,
    firebaseLogin,
    firebaseUpdatePassword,
    firebaseLogout,
    isNotified,
    capitalize,
    checkImage,
    fileExtension,
    classIcon,
    clearAll,
    listToTree,
    convertTimestamptoTime,
    getExperience
};
